import { FormsInputDropdown } from '@platform/components';
import { challengeOptions } from '../dashboard/business-challenges/org-business-challenges-form/consts';
import { FieldValues, Control, Path, FieldError, RegisterOptions } from 'react-hook-form';

type BusinessChallengeSelectionDropdownProps<FData extends FieldValues> = {
  control: Control<FData>;
  name: Path<FData>;
  label: string;
  error?: FieldError;
  rules?: RegisterOptions<FData>;
};

export const BusinessChallengeSelectionDropdown = <FData extends FieldValues>(
  props: BusinessChallengeSelectionDropdownProps<FData>,
) => {
  return (
    <FormsInputDropdown
      {...props}
      placeholder='Select one'
      items={challengeOptions}
      type='default'
    />
  );
};
